import { AgGridColumnType, AgGridExportType, ExportedColDef } from '@/shared/models/ag-grid.model'
import {
    CommonHealthManagementAreaResponse,
    CommonLaboratoryResponse,
    CommonPetitionerResponse
} from '@/api/services/common.dto'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonPriorityResponse } from '@/api/services/common/priority/common-priority.dto'
import i18n from '@/lang/i18n'
import {
    ConfigurationCommonDepartmentResponse
} from '@/modules/configurationModule/detail/local-samples/target-response-times/services/target-response-types.dto'

export interface StatisticalAnalysisExternalListCase {
    caseNumber: string
    registrationDate: string
    caseType: CommonCaseTypeResponse
    priority: CommonPriorityResponse
    pathologist: CommonPersonnelResponse
    informedDate: string
    transcriptionDate: string
    validationDate: string
    episode: string
    externalReference: string
    requestNumber: string
    amended: boolean
    amendmentDate: string
    hasComplementary: boolean
    caseOfReference: boolean
    hasConsults: boolean
    totalURV: number
    totalUCL: number
    caseId: number
    physicianHealthManagementArea: CommonHealthManagementAreaResponse
    physicianDepartment: ConfigurationCommonDepartmentResponse
    physicianPetitioner: CommonPetitionerResponse,
    laboratory: CommonLaboratoryResponse
}

export const StatisticalAnalysisExternalListColumnsCases = ():ExportedColDef[] => {
    return [
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.caseNumber'),
            field: 'caseNumber',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('statisticalAnalysis.grids.registrationDate'),
            field: 'registrationDate',
            exportType: AgGridExportType.DATETIME,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.caseType'),
            field: 'caseType.description',
            exportType: AgGridExportType.TEXT,
            minWidth: 120,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.PRIORITY,
            headerName: i18n.tc('statisticalAnalysis.grids.priority'),
            field: 'priority',
            exportField: 'priority.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 120,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.pathologist'),
            field: 'pathologist.fullName',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('statisticalAnalysis.grids.informedDate'),
            field: 'informedDate',
            exportType: AgGridExportType.DATETIME,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('statisticalAnalysis.grids.transcriptionDate'),
            field: 'transcriptionDate',
            exportType: AgGridExportType.DATETIME,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('statisticalAnalysis.grids.validationDate'),
            field: 'validationDate',
            exportType: AgGridExportType.DATETIME,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.episode'),
            field: 'episode',
            exportType: AgGridExportType.TEXT,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.externalReference'),
            field: 'externalReference',
            exportType: AgGridExportType.TEXT,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.requestNumber'),
            field: 'requestNumber',
            exportType: AgGridExportType.TEXT,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('statisticalAnalysis.grids.amended'),
            field: 'amended',
            exportType: AgGridExportType.BOOLEAN,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('statisticalAnalysis.grids.amendmentDate'),
            field: 'amendmentDate',
            exportType: AgGridExportType.DATETIME,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('statisticalAnalysis.grids.hasComplementary'),
            field: 'hasComplementary',
            exportType: AgGridExportType.BOOLEAN,
            hide: true,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('statisticalAnalysis.grids.consultationCase'),
            field: 'caseOfReference',
            exportType: AgGridExportType.BOOLEAN,
            hide: true,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('statisticalAnalysis.grids.hasConsults'),
            field: 'hasConsults',
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.tc('statisticalAnalysis.grids.valueUnitTotal'),
            field: 'totalURV',
            exportType: AgGridExportType.DOUBLE,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.tc('statisticalAnalysis.grids.workUnitTotal'),
            field: 'totalUCL',
            exportType: AgGridExportType.DOUBLE,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.requestingHealthManagementArea'),
            field: 'physicianHealthManagementArea.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.requestingDepartment'),
            field: 'physicianDepartment.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.requestingCenter'),
            field: 'physicianDepartment.center.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('statisticalAnalysis.grids.requestingProfessional'),
            field: 'physicianPetitioner',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            hide: true,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.LABORATORIES,
            headerName: i18n.tc('global.laboratory'),
            field: 'laboratory.labName',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('global.status'),
            field: 'status',
            type: AgGridColumnType.COMMON_CASE_STATUS,
            exportField: 'status.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        }
    ]
}
